module.exports = __webpack_public_path__ + "img/flag-PR.762c3d38.png";